// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.2002 8.5V3H17.8002V8.5H6.2002Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 21.0001V14.5L19.5 10.5044L4.5 10.5044L2 14.5V21.0001H22Z"}}]};

const InkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ink-filled',
    ref,
    icon: element,
  },
));

InkFilledIcon.displayName = 'InkFilledIcon';

export default InkFilledIcon;
